(() => {
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format(Number(cents || 0) / 100); }
    catch (_) { return `R$ ${(Number(cents || 0) / 100).toFixed(2).replace('.', ',')}`; }
  };

  function initProduct(root) {
    if (root.dataset.gxReady === 'true') return;
    root.dataset.gxReady = 'true';
    const dataNode = root.querySelector('[data-gx-variants]');
    const form = root.querySelector('.gx-product-form');
    if (!dataNode || !form) return;
    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const currency = root.dataset.currency || 'BRL';
    const variantInput = form.querySelector('[data-variant-id]');
    const quantityInput = form.querySelector('[data-quantity-input]');
    const addButton = form.querySelector('[data-add-button]');

    const selectedOptions = () => [...form.querySelectorAll('[data-option-input]:checked')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((input) => input.value);

    const selectedVariant = () => {
      const options = selectedOptions();
      if (!options.length) return variants.find((variant) => String(variant.id) === variantInput.value) || variants[0];
      return variants.find((variant) => Array.isArray(variant.options) && variant.options.every((value, index) => value === options[index]));
    };

    const selectedQuantity = () => Number(form.querySelector('[data-kit-input]:checked')?.value || 1);
    const quantityFactor = (quantity) => ({ 3: 0.95, 5: 0.9 }[quantity] || 1);

    const render = (scrollMedia = false) => {
      const variant = selectedVariant();
      const quantity = selectedQuantity();
      if (!variant) {
        addButton.disabled = true;
        form.querySelector('[data-add-label]').textContent = 'Combinação indisponível';
        return;
      }
      variantInput.value = variant.id;
      variantInput.disabled = false;
      quantityInput.value = quantity;
      root.querySelector('[data-product-price]')?.replaceChildren(document.createTextNode(money(variant.price, currency)));
      form.querySelector('[data-total-price]')?.replaceChildren(document.createTextNode(money(Math.round(variant.price * quantity * quantityFactor(quantity)), currency)));
      form.querySelectorAll('[data-kit-total]').forEach((node) => {
        const kitQuantity = Number(node.dataset.kitTotal);
        node.textContent = money(Math.round(variant.price * kitQuantity * quantityFactor(kitQuantity)), currency);
      });
      root.querySelector('[data-installment-price]')?.replaceChildren(document.createTextNode(money(Math.round(variant.price / 10), currency)));
      const compare = form.closest('[data-gx-product]').querySelector('[data-compare-price]');
      const badge = form.closest('[data-gx-product]').querySelector('[data-discount-badge]');
      const tag = form.closest('[data-gx-product]').querySelector('[data-discount-tag]');
      const hasDiscount = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      const discount = hasDiscount ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      if (compare) { compare.hidden = !hasDiscount; compare.textContent = hasDiscount ? money(variant.compare_at_price, currency) : ''; }
      if (badge) { badge.hidden = !hasDiscount; badge.textContent = `${discount}% OFF`; }
      if (tag) { tag.hidden = !hasDiscount; tag.textContent = `${discount}% OFF`; }
      form.querySelector('[data-selection-label]').textContent = variant.title || selectedOptions().join(' / ');
      form.querySelector('[data-quantity-label]').textContent = quantity === 1 ? '1 unidade' : `${quantity} unidades`;
      addButton.disabled = !variant.available;
      form.querySelector('[data-add-label]').textContent = variant.available ? 'Adicionar à sacola' : 'Produto esgotado';
      const stock = root.querySelector('[data-stock-note]');
      if (stock) stock.textContent = variant.available ? 'Disponível para compra — prazo calculado no checkout.' : 'Esta combinação está esgotada.';
      form.querySelectorAll('[data-option-input]:checked').forEach((input) => {
        const output = form.querySelector(`[data-option-value="${input.dataset.optionPosition}"]`);
        if (output) output.textContent = input.value;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
      if (scrollMedia && variant.featured_media?.id) {
        root.querySelector(`[data-media-id="${variant.featured_media.id}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-input], [data-kit-input]')) render(event.target.matches('[data-option-input]'));
    });
    render(false);
  }

  function initGallery(root) {
    root.querySelectorAll('.gx-gallery__item img').forEach((image) => {
      image.closest('button')?.addEventListener('click', () => {
        const dialog = document.createElement('dialog');
        dialog.className = 'gx-media-dialog';
        const close = document.createElement('button');
        close.type = 'button'; close.setAttribute('aria-label', 'Fechar'); close.textContent = '×';
        const large = image.cloneNode();
        if (image.currentSrc) large.src = image.currentSrc.replace(/width=\d+/, 'width=2000');
        dialog.append(large, close); document.body.append(dialog);
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => dialog.remove());
        dialog.showModal();
      });
    });
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-gx-product]').forEach((root) => { initProduct(root); initGallery(root); });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// Tabela de medidas em modal: usa a seção da página atual ou busca a do guia.
(() => {
  let guidePromise = null;
  const loadGuide = () => {
    const local = document.getElementById('gx-size-guide');
    if (local) return Promise.resolve(local);
    guidePromise ||= fetch('/pages/guia-de-medidas')
      .then(response => response.text())
      .then(html => new DOMParser().parseFromString(html, 'text/html').getElementById('gx-size-guide'))
      .catch(() => null);
    return guidePromise;
  };
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-gx-size-open]');
    if (!trigger) return;
    event.preventDefault();
    const guide = await loadGuide();
    if (!guide) { window.location.href = '/pages/guia-de-medidas'; return; }
    const dialog = document.createElement('dialog');
    dialog.className = 'gx-size-dialog gx-size-dialog--dark';
    dialog.setAttribute('aria-label', 'Tabela de medidas');
    const panel = document.createElement('div');
    panel.className = 'gx-size-dialog__panel';
    panel.innerHTML = '<div class="gx-size-dialog__top"><strong>Tabela de medidas</strong><button type="button" class="gx-size-dialog__close" aria-label="Fechar">×</button></div>';
    guide.querySelectorAll('.gx-measure-group, .gx-measure-how').forEach(node => panel.append(node.cloneNode(true)));
    dialog.append(panel);
    document.body.append(dialog);
    panel.querySelector('.gx-size-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => dialog.remove());
    dialog.showModal();
  });
})();
